import Modal from 'components/Modal/Modal';
import React from 'react';
import 'styles/duplicateConnexion.css';
import Button from './Button/Button';

interface DuplicateConnectionProps {
  isOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const DuplicateConnection: React.FC<DuplicateConnectionProps> = ({
  isOpen,
  setIsModalOpen,
}) => {
  const handleClose = () => {
    setIsModalOpen(false);
    window.location.reload();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      showHeader={true}
      title='Connexion en double'
    >
      <div className='duplicate-connection-content'>
        <p>
          Une autre connexion a été établie avec votre compte. Vous allez être
          déconnecté de cette session.
        </p>
        <p>
          Si ce n'est pas vous, nous vous recommandons de vérifier votre compte
          pour d'éventuelles activités suspectes.
        </p>
        <Button onClick={handleClose} label='OK, compris' color='secondary' />
      </div>
    </Modal>
  );
};

export default DuplicateConnection;
